import React, { Component } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";

import './styles/App.css';
import Home from './Home';
//import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import StudentList from './components/StudentList';
import StudentEdit from "./components/StudentEdit";
import ContractList from "./components/ContractList";
import ContractEdit from "./components/ContractEdit";
import FormationList from "./components/FormationList";
import SessionList from "./components/SessionList";
import DossierList from './components/DossierList';

import Login from './components/Login';
import Logout from './components/Logout';

import AuthService from "./services/LoginService";
import AuthVerify from "./common/auth-verify";
import AppNavbar from "./AppNavbar";
//import AppNavbar from "./AppNvabar2";


import { ThemeProvider, createTheme } from '@mui/material/styles';


// use default theme
// const theme = createTheme();

// Or Create your Own theme:
const theme = createTheme({
  palette: {
    warning: {
      main: '#FFFF00'
    },
    danger: {
      main: '#FF0000'
    }
  },
  
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          fontSize: '13px',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '13px',
        },
      },
    },
  },
});






class App extends Component {




  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    this.state = {
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
    };
  }

  componentDidMount() {
    const user = AuthService.getCurrentUser();

    if (user) {
      this.setState({
        currentUser: user,
        // showModeratorBoard: user.roles.includes("ROLE_MODERATOR"),
        // showAdminBoard: user.roles.includes("ROLE_ADMIN"),
      });
    }
  }

  logOut() {
    AuthService.logout();
    this.setState({
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
    });
  }


  render() {
    return (
      <ThemeProvider theme={theme}>
        <div >
          <Router>
            <AppNavbar />
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/logout" element={<Logout />} />
              <Route path='/students' element={<StudentList />} />
              <Route path='/students/:id' element={<StudentEdit />} />
              <Route path='/contracts' element={<ContractList />} />
              <Route path='/contracts/:id' element={<ContractEdit />} />

              <Route path='/formations' element={<FormationList />} />
              <Route path='/sessions' element={<SessionList />} />
              <Route path='/dossiers' element={<DossierList />} />

            </Routes>
            <AuthVerify logOut={this.logOut} />
          </Router>
        </div>
      </ThemeProvider>

    );
  }
}

export default App;
